var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container",attrs:{"id":"web-swiper"}},[_c('div',{ref:"mySwiper",staticClass:"swiper-wrapper"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }